import { FavPopupContentManageFavs } from 'components/search-bar-fav/popover-manage-favs/fav-popup-content-manage-favs.js';
import { StickyPosition } from 'page-context/scrollStickyStateProvider/scrollStickyMain.js';
import * as React from 'react';
import { Popover, PopoverState } from 'react-tiny-popover';
import { useAppSelector } from 'redux-state/configure-store.js';
import { MAX_FAVOURITES_TO_SHOW } from 'redux-state/favourites/types.js';
import { PW_FAVOURITE_MENU_BUTTON } from 'utilities/consts/variable-types.js';

/** Displays favourite icons (favourited locations, star and add) on search bar and associated popups to manage favourites. */
export const FavPopupMainManageFavs = ({ children }: { children: JSX.Element }) => {
  const { allItems, topItems: favTop, bottomItems: favBottom } = useAppSelector((s) => s.FAVOURITES);
  const { stickyBarForceDisplay } = React.useContext(StickyPosition);
  const [dropdownIsOpen, setDropdown] = React.useState(false);

  React.useEffect(() => {
    stickyBarForceDisplay?.(dropdownIsOpen);
  }, [dropdownIsOpen, stickyBarForceDisplay]);

  return (
    <div
      data-comp="favourite-popover-manage"
      className="SearchBar-favourites-dropdown-trigger"
      data-testid={PW_FAVOURITE_MENU_BUTTON}
      onClick={() => setDropdown((c) => !c)}
    >
      <Popover
        parentElement={undefined} // do not use refs here from parent el e.g. like fav-added-main as it causes popover to be glitchy
        isOpen={dropdownIsOpen}
        onClickOutside={(e: MouseEvent) => {
          setDropdown(false);
          /** If clicking on the icon we need to ensure that this does not bubble down */
          e.stopPropagation();
        }}
        align="center"
        // reposition={false}
        positions={['bottom', 'right', 'left', 'top']}
        containerClassName="SearchBar-favourites-popover SearchBar-favourites-popover--list"
        content={({ childRect, popoverRect, position }: PopoverState) => (
          <FavPopupContentManageFavs
            childRect={childRect}
            position={position}
            popoverRect={popoverRect}
            topFavourites={allItems.slice(0, MAX_FAVOURITES_TO_SHOW)}
            favouriteTopItems={favTop}
            favouriteBottomItems={favBottom}
            dropdownClicked={() => setDropdown((c) => !c)}
          />
        )}
      >
        {/* 
            This click holds the click event
            The child you supply react-tiny-popover with needs to support ref 
            */}
        {children}
      </Popover>
    </div>
  );
};
